

























































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import FormsGlobal from '../../../mixins/FormsGlobal';
import { FormRow, Logic } from "../../../models/Form";
import { TranslateResult } from "vue-i18n";

@Component
export default class FieldsetWrap extends Vue {
  @Prop({ type: Object, required: true }) row!: FormRow;
  @Prop({ type: Object, required: true }) rows!: { [key: string]: FormRow };
  @Prop({ type: String }) tip!: string;
  @Prop({ type: Function }) onClick!: Function;
  @Prop({ type: Boolean }) isDisabled!: boolean;
  @Prop({ type: Boolean }) isHidden!: boolean;
  @Prop({ type: Boolean }) isComponentError!: boolean;
  @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
  processedRows = new Set<string>();

  get childRows() {
    return Object.values(this.rows)
      .filter(childRow => childRow.parentId === this.row.rowCode)
      .sort((a, b) => a.order - b.order);
  }

  handleClick() {
    if (this.onClick) {
      this.onClick(this.tip);
    }
  }

  getFieldClasses(row: FormRow) {
    let mobileWidth = '100';
    let desktopWidth = '100';

    if (row.styleJson) {
      try {
        const style = JSON.parse(row.styleJson);
        if (Array.isArray(style) && style.length > 0) {
          mobileWidth = style[0].mobile || '100';
          desktopWidth = style[0].desktop || '100';
        }
      } catch (error) {
        console.error('Error parsing styleJson:', error);
      }
    }

    return {
      'w-full': mobileWidth === '100',
      'w-1/2': mobileWidth === '50',
      'md:w-full': desktopWidth === '100',
      'half-class': desktopWidth === '50',
    };
  }

  get options() {
    if (this.row.comboValues) {
      return Object.entries(this.row.comboValues)
        .map(([value, label]) => ({ value, label }))
        .sort((a, b) => a.value.localeCompare(b.value, undefined, { numeric: true }));
    }
    return [];
  }

  getComponent(type: string, isParent: boolean) {
    return FormsGlobal.getComponent(type, isParent);
  }

  evaluateExpressionLogic(expressionLogic: Logic[]) {
    if (!expressionLogic || !Array.isArray(expressionLogic)) return false;

    return expressionLogic.every((logic: Logic) => {
      const targetRow = this.rows[logic.id_riga];
      if (!targetRow) return false;
      const valueToCheck = logic.value.toLowerCase();
      switch (logic.type) {
        case 'boolean':
          return targetRow.valCheck === null && (logic.value === 'true');
        case 'contain':
          return targetRow.valText && targetRow.valText.toLowerCase().includes(valueToCheck) ||
                 targetRow.valCombo && targetRow.valCombo.toLowerCase().includes(valueToCheck);
        case 'empty':
          return !targetRow.valText;
        default:
          return false;
      }
    });
  }

  isRowOutcome(row: FormRow, outcome: 'disable' | 'hide' | 'show'): boolean {
    let expressionLogic: Logic[] = [];
    try {
      expressionLogic = JSON.parse(row.expressionLogic);
    } catch (error) {
      console.error('Error parsing expressionLogic:', error);
    }
    if (Array.isArray(expressionLogic)) {
      return expressionLogic.some((logic: Logic) => {
        return logic.outcome === outcome && this.evaluateExpressionLogic([logic]);
      });
    }
    return false;
  }

  isRowDisabled(childRow: FormRow) {
    return childRow.disabled === true || this.isRowOutcome(childRow, 'disable');
  }

  isRowHidden(childRow: FormRow) {
    if (!childRow.expressionLogic) {
      return false; // Show by default if there is no expression logic
    }

    const showOutcome = this.isRowOutcome(childRow, 'show');
    const hideOutcome = this.isRowOutcome(childRow, 'hide');

    if (hideOutcome) {
      return true; // Hide if the hide condition is met
    }

    if (!showOutcome && childRow.expressionLogic.includes('"outcome": "show"')) {
      return true; // Hide if there is a show condition and it is not met
    }

    return false; // Otherwise, show the row
  }
}
